import React from 'react'

import { useTranslation } from 'react-i18next'
import { BasicButton } from '@pokemon/design.ui.input.basic-button'

export function ErrorFallback ({ header, text, primaryButton = {}, secondaryButton = {} }) {
  const { t } = useTranslation()

  return (
    <>
      <div className='title-wrapper'>
        <h2>
          {header || t('landing_screen_header', 'Recover Your Pokemon Trainer Account')}
        </h2>
        <p className='sub-title'>
          {text || t('generic_error', 'Oops! It looks like something went wrong.')}
        </p>
      </div>
      { primaryButton ? 
        <BasicButton 
          type={'link'}
          href={primaryButton.url || "https://support.pokemon.com"}
          text={primaryButton.text || t('customer_support', 'Contact Customer Support')}/> : 
        null }
      { secondaryButton ? 
        <BasicButton 
          type={'link'}
          href={secondaryButton.url || "https://pokemon.com"}
          text={secondaryButton.text || t('return_to_login', 'Return to Login')}
          style={{ marginTop: '10px', width: '100%' }} buttonStatus={'secondary'} /> : 
        null }
    </>
  )
}

export default ErrorFallback
